import React, { createContext, useContext } from 'react';

export const ScanInfoContext = createContext();

export const useScanInfoContext = () => useContext(ScanInfoContext);

const ScanInfoProvider = ({ children, customerId, domainId, scanId, organizationId, triggerStatsFetch, setTriggerStatsFetch, triggerListFetch, setTriggerListFetch, contextCurrentPage, setContextCurrentPage }) => {
    return (
        <ScanInfoContext.Provider value={{ customerId, domainId, scanId, organizationId, triggerStatsFetch, setTriggerStatsFetch, triggerListFetch, setTriggerListFetch, contextCurrentPage, setContextCurrentPage}}>
            {children}
        </ScanInfoContext.Provider>
    );
};

export default ScanInfoProvider;